import React from 'react';
import { motion } from 'framer-motion';

const socialLinks = [
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/ieeespoch',
    icon: (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M18 2h-3a4 4 0 0 0-4 4v3H8v4h3v8h4v-8h3l1-4h-4V6a1 1 0 0 1 1-1h3V2z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/ieeespoch',
    icon: (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="18" height="18" rx="5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 11.37a4 4 0 1 1-3.99-4 4 4 0 0 1 3.99 4z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17.5 6.5h.01" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/school/espoch',
    icon: (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M16 8a6 6 0 0 1 6 6v7H16v-7a2 2 0 0 0-4 0v7H8V8h4v2a2 2 0 0 1 4 0V8z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 9h4v12H2z" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="4" cy="4" r="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    name: 'GitHub',
    href: 'https://github.com/ieeespoch',
    icon: (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9 19c-4.5 1.5-4.5-2-6-2m12 4v-2.2a3.2 3.2 0 0 0-.86-2.23c2.88-.32 5.91-1.44 5.91-6.42a5 5 0 0 0-1.33-3.49a4.66 4.66 0 0 0-.12-3.44s-1.08-.35-3.54 1.32a12.2 12.2 0 0 0-6.42 0C6.6 3.06 5.5 3.41 5.5 3.41A4.66 4.66 0 0 0 4.18 6.85a5 5 0 0 0-1.33 3.49c0 4.98 3.02 6.1 5.9 6.42A3.2 3.2 0 0 0 8 20.8V23" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/ieeespoch',
    icon: (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 7.5a2.5 2.5 0 0 0-2.5-2.5H5.5A2.5 2.5 0 0 0 3 7.5v9A2.5 2.5 0 0 0 5.5 19h13A2.5 2.5 0 0 0 21 16.5v-9z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="m10 15 5-3-5-3v6z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-50 py-24">
      <div className="mx-auto max-w-7xl px-6 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-4 mb-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2 space-y-8"
          >
            <img
              src="/assets/logos_rama_general_completos/Logo_completo_azul.png"
              alt="IEEE Logo"
              className="h-12 w-auto object-contain"
            />
            <p className="text-slate-600 text-lg leading-relaxed max-w-md font-normal">
              IEEE ESPOCH une el talento académico con la innovación tecnológica. Liderazgo estudiantil, eventos de alto impacto y comunidad global.
            </p>
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  whileHover={{ y: -4, scale: 1.05 }}
                  className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-white border border-slate-200 text-slate-600 transition-all duration-300 hover:border-indigo-300 hover:text-indigo-600 hover:shadow-sm"
                  title={social.name}
                >
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-6"
          >
            <h4 className="text-sm font-black uppercase tracking-[0.2em] text-slate-900">Ubicación</h4>
            <p className="text-slate-600 leading-relaxed font-normal">
              Escuela Superior Politécnica de Chimborazo<br />
              Panamericana Sur Km 1 1/2<br />
              Riobamba, Ecuador
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="space-y-6"
          >
            <h4 className="text-sm font-black uppercase tracking-[0.2em] text-slate-900">Contacto</h4>
            <p className="text-slate-600 leading-relaxed font-normal">
              <a href="mailto:ieee.estudiantil@espoch.edu.ec" className="hover:text-indigo-600 transition-colors">ieee.estudiantil@espoch.edu.ec</a><br />
              +593 97 897 2191
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-20 pt-10 border-t border-slate-200 flex flex-col md:flex-row md:items-center md:justify-between gap-6"
        >
          <p className="text-sm text-slate-500 font-normal">
            © 2026 IEEE ESPOCH — Todos los derechos reservados.
          </p>
          <div className="flex flex-wrap gap-8 text-sm font-semibold text-slate-600">
            <a href="#privacy" className="hover:text-indigo-600 transition-colors">Privacidad</a>
            <a href="#terms" className="hover:text-indigo-600 transition-colors">Términos</a>
            <a href="#conduct" className="hover:text-indigo-600 transition-colors">Conducta</a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
